/**
 * ---------------------------------------------------------------------------------
 *
 * 	This page consists of two buttons that navigate to the OverfittingPage and
 *  UnderfittingPage. It also contains the embedded Youtube demo for the picture
 *  classification theme. 
 * 
 * ----------------------------------------------------------------------------------
 */

import React from 'react';
import PermanentDrawerLeft from '../../components/PermanentDrawerLeft';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import YoutubeComponent from '../../components/Youtube';

const useStyles = makeStyles((theme) => ({

  content: {
    paddingLeft: '280px',
    paddingTop: '100px',
    backgroundColor: 'white',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttons: {
    textAlign: 'center',
  },
  button: {
    maxWidth: '300px',
    minWidth: '300px',
    minHeight: '40px'
  },
}));

function ImageMenuPage() {
  const history = useHistory();
  const classes = useStyles();

  return (
    <div>
      <PermanentDrawerLeft></PermanentDrawerLeft>
      <main className={classes.content}>
        <div className={classes.buttons}>
          <Button className={classes.button} variant="contained" color="primary" onClick={() => history.push('./overfitting')}>Overfitting</Button>
          <br /><br />
          <Button className={classes.button} variant="contained" color="primary" onClick={() => history.push('./underfitting')}>Underfitting</Button>
          <br /><br />
          <YoutubeComponent link={`https://www.youtube.com/embed/jAkk48B_768`} />
        </div>

      </main>
    </div>
  );
}

export default ImageMenuPage;